module.exports = __webpack_public_path__ + "img/swiper_3.57a23791.png";